import styled, { css } from 'styled-components';

import { ReactComponent as HiddenSvg } from '@pkg/assets/icons/hidden.svg';
import { ReactComponent as GlobeSvg } from '@pkg/assets/icons/v2/social/geometric-globe.svg';

export const GlobeIcon = styled(GlobeSvg)`
    && {
        fill: none;
        width: 20px;
        height: 20px;
        padding: 3px;
        margin-right: 2px;
    }
`;
export const HiddenIcon = styled(HiddenSvg)`
    && {
        width: 20px;
        height: 20px;
        padding: 3px;
        margin-right: 2px;
    }
`;

export const PrivacyWrapper = styled.div`
    margin: 24px 0;
    display: flex;
    flex-direction: column;
    gap: 20px;
`;

export const PrivacyInner = styled.div`
    background: rgba(255, 255, 255, 0.05);
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    background: rgba(255, 255, 255, 0.05);
    border-radius: 10px;
    padding: 0 20px;
`;

export const PrivacyItem = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    width: 100%;
    padding: 20px 22px 20px 0;
    position: relative;
    cursor: pointer;
    :first-of-type {
        border-bottom: 1px solid rgba(255, 255, 255, 0.1);
    }
    &:hover {
        .radio {
            border: 1.5px solid #523df1 !important;
        }
    }
`;

export const PrivacyHeading = styled.div`
    font-weight: 700;
    font-size: 18px;
    line-height: 100%;
    letter-spacing: -0.02em;
    color: #ffffff;
`;

export const ButtonWrapper = styled.div`
    && {
        button {
            width: 100% !important;
        }
    }
`;

export const PrivacyLabel = styled.div`
    font-weight: 700;
    font-size: 16px;
    line-height: 100%;
    display: flex;
    justify-content: flex-start;
    align-items: center;
`;

export const PrivacyDesc = styled.div`
    font-weight: 500;
    font-size: 14px;
    line-height: 120%;
    color: rgba(255, 255, 255, 0.5);
    margin-top: 4px;
`;

export const Radio = styled.div<{ $active?: boolean }>`
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    padding: 0;
    gap: 10px;
    width: 20px;
    height: 20px;
    border: 1.5px solid rgba(255, 255, 255, 0.3);
    border-radius: 100px;
    transition: 0.3s;
    position: absolute;
    right: 0;
    top: 50%;
    transform: translateY(-50%);
    div {
        width: 10px;
        height: 10px;
        background: #523df1;
        flex: none;
        order: 0;
        flex-grow: 0;
        opacity: 0;
        transition: 0.3s;
        border-radius: 50%;

        ${({ $active }) =>
            $active &&
            css`
                opacity: 1;
            `};
    }

    ${({ $active }) =>
        $active &&
        css`
            border: 1.5px solid #523df1;
        `};
`;
